import { useTranslation } from 'next-i18next';
import React from 'react';
import Tooltip from 'react-tooltip-lite';

import { getCardData } from '@/modules/Settlements/components/Details/CrewLevel/MainPayablesDays/logic';
import { ISettlements } from '@/modules/Settlements/types';
import { Typography } from '@/shared/components/atoms';
import { useStore } from '@/shared/hooks/context/createGenericContext';

import ExleminationMark from '~/images/shared/ExleminationMark.svg';

interface Props {
  data: ISettlements.ISettlementDetailsDay;
}

const CardContent: React.FC<Props> = ({ data }) => {
  // const { openModal } = useModal();
  const [selectedAsset] = useStore((store) => store?.asset);

  const {
    t,
    i18n: { language },
  } = useTranslation('common');
  const cardData = getCardData({
    data,
    currency: selectedAsset?.currency || '',
    language,
  });

  // const menuList = [
  //   {
  //     title: 'test1',
  //     id: 'test1',
  //     action: () => openModal(<>test</>),
  //   },
  //   {
  //     title: 'test2',
  //     id: 'test2',
  //     action: () => openModal(<>test2</>),
  //   },
  //   {
  //     title: 'test3',
  //     id: 'test3',
  //     action: () => openModal(<>test3</>),
  //   },
  //   {
  //     title: 'test4',
  //     id: 'test4',
  //     action: () => openModal(<>test4</>),
  //   },
  // ];

  return (
    <div className='flex w-full items-center gap-2'>
      <div className='flex w-full items-center justify-between gap-12 overflow-x-auto  whitespace-nowrap border-primary-300 py-16 overflow-y-hidden scrollbar-thin scrollbar-thumb-background-disable scrollbar-thumb-rounded-lg scrollbar-w-5 scrollbar-h-5'>
        {Object.entries(cardData).map(([key, value]) => (
          <div key={key} className='max-w-1/5 flex flex-col gap-1'>
            <div className='w-fit'>
              <Typography variant='body2' className='text-text-600'>
                {t(key)}
              </Typography>

              <Typography
                variant='subtitle2'
                className='relative text-black'
                weight={key === 'total-dues' ? 'bold' : 'regular'}
              >
                {key === 'main-dues' ||
                key === 'supervisionDeduction' ||
                key === 'extra-supervision' ||
                key === 'extra-hours' ? (
                  <Tooltip
                    content={
                      <Typography className='w-fit min-w-[200px] max-w-[400px] rounded-lg bg-background-200 px-16 py-4 text-center'>
                        {t(key + '-tool-tip-info')}
                      </Typography>
                    }
                    direction='down'
                    arrow={false}
                    tipContentHover
                  >
                    <div className='flex items-center justify-center gap-2 '>
                      {value} <ExleminationMark />
                    </div>
                  </Tooltip>
                ) : (
                  value
                )}
              </Typography>
            </div>
          </div>
        ))}
      </div>
      {/* <DotedMenu
        list={menuList}
        getTitle={(item) => item.title}
        getId={(item) => item?.id}
        getAction={(item) => item.action}
        // eslint-disable-next-line no-console
        onOpen={() => console.log('opened')}
      /> */}
    </div>
  );
};

export default CardContent;
